//#region import
import React, { useEffect, useRef, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
import { BtnBack, BtnSave, BtnSearch } from "components/Button/ButtonAll";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import { FormProvider, useForm } from "react-hook-form";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import DataGrid, { PaginationInterface, initRows } from "components/DataGrid";
import { GridColDef } from "@mui/x-data-grid-pro";
import moment from "moment";
import { GetMenuPermission } from "utilities/SystemFunction";
import { useNavigate } from "react-router";
import { optionsProps } from "components/Input/Select/SelectProps";
import { TextBoxItem } from "components/Input/TextBox";
import { SelectItem } from "components/Input/Select/SelectItem";
import {
  BtnEditOnTable,
  BtnUploadOnTable,
} from "components/Button/ButtonTable";
import DialogPreview from "components/DialogPreview/DialogPreview";
import UploadFile from "components/Input/UploadFile";
import { TimePickerItem } from "components/Input/TimePicker";
//#endregion

interface IMonthlyFile {
  nOrder: number;
  nYear: number;
  nMonth: number;
  sLabel: string;
  lstMonthlyFile: any[];
}

export default function TimeAttendanceEdit() {
  const navigate = useNavigate();
  const AxiosFn = FnAxios();
  const DialogFn = FnDialog();
  const [loadingTable, setLoadingTable] = useState(false);

  const arrStatusSearch: optionsProps[] = [
    { value: "1", label: `${I18n.SetText("TimeAttendance.sNormal")}` },
    { value: "2", label: `${I18n.SetText("TimeAttendance.sLate")}` },
    { value: "3", label: `${I18n.SetText("TimeAttendance.sMissingWork")}` },
    { value: "4", label: `${I18n.SetText("TimeAttendance.sNoCheckIn")}` },
    { value: "5", label: `${I18n.SetText("TimeAttendance.sNoCheckOut")}` },
  ];

  const [arrName, setArrName] = useState([]);
  const [arrStatus, setArrStatus] = useState([]);
  const [dStart, setStart] = useState(null);

  //Upload File
  const arrExtentionMonthlyFile = [
    "pdf",
    "jpg",
    "jpeg",
    "png",
    "doc",
    "docx",
    "rar",
    "zip",
  ];
  const [arrAttachFile, setArrAttachFile] = useState([]);
  const [IsOpenUpload, setIsOpenUpload] = useState(false);
  const [nNoUpload, setNoUpload] = useState(null);
  const handleClearAttachFile = useRef(null);
  const handleClearMonthlyFile_1 = useRef(null);
  const handleClearMonthlyFile_2 = useRef(null);

  //Monthly File
  const [lstMonthlyDoc, setLstMonthlyDoc] = useState<IMonthlyFile[]>([]);

  const [arrMonthlyFile_1, setArrMonthlyFile_1] = useState([]);
  const [arrMonthlyFile_2, setArrMonthlyFile_2] = useState([]);

  const [nPermission, setPermission] = useState<boolean>(false); // Permission

  const form = useForm({
    shouldFocusError: true,
    shouldUnregister: false,
    mode: "all",
  });
  const formSearch = useForm({
    shouldFocusError: true,
    shouldUnregister: false,
    mode: "all",
  });

  //Table
  const [dataRow, setDataRow] = useState<PaginationInterface>({
    ...initRows,
    nPageSize: 9999,
  });
  let dataColumn: GridColDef[] = [
    {
      field: "sUserName",
      headerName: `${I18n.SetText("TimeAttendance.sName")}`,
      headerAlign: "center",
      align: "left",
      sortable: false,
      flex: 2,
      minWidth: 200,
    },
    {
      field: "sWorking",
      headerName: `${I18n.SetText("TimeAttendance.sWorkDay")}`,
      headerAlign: "center",
      align: "center",
      sortable: false,
      width: 100,
    },
    {
      field: "sCheckIn",
      headerName: `${I18n.SetText("TimeAttendance.sCheckIn")}`,
      headerAlign: "center",
      align: "center",
      sortable: false,
      width: 135,
      renderCell: (item) => (
        <TimePickerItem
          id={`tCheckIn_${item.row.sID}`}
          name={`tCheckIn_${item.row.sID}`}
          label={""}
          required={false}
          IsShowMessageError={false}
          disabled={!nPermission || !item.row.isCheckToEdit}
        />
      ),
    },
    {
      field: "sCheckOut",
      headerName: `${I18n.SetText("TimeAttendance.sCheckOut")}`,
      headerAlign: "center",
      align: "center",
      sortable: false,
      width: 135,
      renderCell: (item) => (
        <TimePickerItem
          id={`tCheckOut_${item.row.sID}`}
          name={`tCheckOut_${item.row.sID}`}
          label={""}
          required={false}
          IsShowMessageError={false}
          disabled={!nPermission || !item.row.isCheckToEdit}
        />
      ),
    },
    {
      field: "sStatusWork",
      headerName: `${I18n.SetText("TimeAttendance.sStatusWork")}`,
      headerAlign: "center",
      align: "center",
      sortable: false,
      width: 250,
      renderCell: (item) => (
        <Grid item xs={12} sx={{ mt: "5px", mb: "5px" }}>
          <SelectItem
            id={`nStatusID_${item.row.sID}`}
            name={`nStatusID_${item.row.sID}`}
            label=""
            options={arrStatus || []}
            required={item.row.isCheckToEdit}
            IsShowMessageError={false}
            disabled={!nPermission || !item.row.isCheckToEdit}
          />
        </Grid>
      ),
    },
    {
      field: "sRemark",
      headerName: `${I18n.SetText("TimeAttendance.sRemark")}`,
      headerAlign: "center",
      align: "center",
      sortable: false,
      width: 250,
      renderCell: (item) => (
        <TextBoxItem
          id={`sRemark_${item.row.sID}`}
          name={`sRemark_${item.row.sID}`}
          label=""
          maxLength={150}
          required={false}
          IsShowMessageError={false}
          type={"text"}
          disabled={!nPermission || !item.row.isCheckToEdit}
        />
      ),
    },
    {
      field: "lstAttachFile",
      headerName: `${I18n.SetText("TimeAttendance.sAttachFile")}`,
      headerAlign: "center",
      align: "center",
      sortable: false,
      width: 80,
      renderCell: (item) =>
        item.row.lstAttachFile && item.row.lstAttachFile.length > 0 ? (
          <BtnEditOnTable
            id="btnEdit"
            key={"btnEdit"}
            IsDisabled={!nPermission || !item.row.isCheckToEdit}
            onClick={() => {
              handleSetUploadFile(item.row.sID);
            }}
          />
        ) : (
          <BtnUploadOnTable
            id={"btnUpload"}
            onClick={() => {
              setIsOpenUpload(true);
              setNoUpload(item.row.sID);
            }}
            IsDisabled={!nPermission || !item.row.isCheckToEdit}
          />
        ),
    },
  ];
  const handleSetUploadFile = (sID) => {
    let objRow = dataRow.arrRows.find((f) => f.sID === sID);
    if (objRow.lstAttachFile.length > 0) {
      setArrAttachFile(objRow.lstAttachFile);
      setNoUpload(sID);
      setIsOpenUpload(true);
    }
  };
  const getTable = (p: PaginationInterface) => {
    //ห้ามค้นหาเกิน 7 วัน
    let nDiffDate = moment(formSearch.getValues("dEnd")).diff(
      moment(formSearch.getValues("dStart")),
      "days"
    );
    if (nDiffDate > 5) {
      DialogFn.Warning("สามารถค้นหาข้อมูลได้ไม่เกิน 7 วัน");
      return false;
    }

    setLoadingTable(true);
    let objParam = {
      ...p,
      lstNameID: formSearch.getValues("arrName") || [],
      nStart: formSearch.getValues("dStart")
        ? new Date(formSearch.getValues("dStart")).valueOf()
        : null,
      nEnd: formSearch.getValues("dEnd")
        ? new Date(formSearch.getValues("dEnd")).valueOf()
        : null,
      lstStatusID: formSearch.getValues("arrStatus") || [],
    };
    AxiosFn.Post(`TimeAttendance/GetTableEdit`, objParam, (result) => {
      //Set Form Data
      result.lstData.forEach((f) => {
        form.setValue(
          "tCheckIn_" + f.sID,
          f.dCheckIn ? moment(f.dCheckIn) : null
        );
        form.setValue(
          "tCheckOut_" + f.sID,
          f.dCheckOut ? moment(f.dCheckOut) : null
        );
        form.setValue("nStatusID_" + f.sID, f.nStatus);
        form.setValue("sRemark_" + f.sID, f.sRemark);
      });
      setLoadingTable(false);
      setDataRow({
        ...p,
        arrRows: [...result.lstData],
        nDataLength: result.ObjTable?.nDataLength,
        nPageIndex: result.ObjTable?.nPageIndex,
      });

      //Monthly Doc
      setLstMonthlyDoc(result.lstMonthlyDoc);
      result.lstMonthlyDoc.forEach((iF) => {
        switch (iF.nOrder) {
          case 1:
            setArrMonthlyFile_1(iF.lstMonthlyFile);
            break;
          case 2:
            setArrMonthlyFile_2(iF.lstMonthlyFile);
            break;
        }
      });
    });
  };
  const handleSearch = () => {
    getTable(dataRow);
  };
  const getFormInitial = () => {
    DialogFn.BlockUI();

    AxiosFn.Get(`TimeAttendance/GetFormInitial`, {}, (result) => {
      DialogFn.UnBlockUI();
      setArrName(result.lstNameActive);
      setArrStatus(result.lstStatus);
      formSearch.setValue("dStart", moment(result.dStart));
      setStart(moment(result.dStart));
      formSearch.setValue("dEnd", moment(result.dEnd));

      getTable(dataRow);
    });
  };
  const handleSelectChange = (arrIDSel) => {
    let arrClone = dataRow;

    arrClone.arrRows.forEach((f) => {
      f.isCheckToEdit = arrIDSel.includes(f.sID);
    });

    setDataRow({ ...arrClone });
  };

  const handleSubmit = () => {
    let lstEdit = dataRow.arrRows.filter((f) => f.isCheckToEdit);
    lstEdit.forEach((f) => {
      f.dCheckIn = form.getValues(`tCheckIn_${f.sID}`)
        ? new Date(form.getValues(`tCheckIn_${f.sID}`)).valueOf()
        : null;
      f.dCheckOut = form.getValues(`tCheckOut_${f.sID}`)
        ? new Date(form.getValues(`tCheckOut_${f.sID}`)).valueOf()
        : null;
      f.nAttendanceStatusID = form.getValues(`nStatusID_${f.sID}`);
      f.sRemark = form.getValues(`sRemark_${f.sID}`);
    });

    lstMonthlyDoc.forEach((f) => {
      if (f.nOrder === 1) {
        f.lstMonthlyFile = arrMonthlyFile_1 || [];
      } else {
        f.lstMonthlyFile = arrMonthlyFile_2 || [];
      }
    });

    let objParam = {
      lstDataEdit: lstEdit,
      lstMonthlyDoc: lstMonthlyDoc,
    };

    DialogFn.Submit(`${I18n.SetText("PublishDoc.sConfirmSave")}`, () => {
      DialogFn.BlockUI();
      AxiosFn.Post(`TimeAttendance/OnSubmit`, objParam, () => {
        DialogFn.UnBlockUI();
        DialogFn.Success(`${I18n.SetText("PublishDoc.sSaveSuccess")}`, () =>
          navigate("/TimeAttendanceDetail")
        );
      });
    });
  };

  const handleConfirmUpload = () => {
    let arrClone = dataRow;
    let objClone = arrClone.arrRows.find((f) => f.sID === nNoUpload);
    if (arrAttachFile.length > 0) {
      objClone.lstAttachFile = arrAttachFile;
    } else {
      objClone.lstAttachFile = [];
    }
    arrClone.arrRows = [...arrClone.arrRows];
    setDataRow({ ...arrClone });
    setIsOpenUpload(false);
    setArrAttachFile([]);
    handleClearAttachFile.current(null);
  };

  useEffect(() => {
    GetMenuPermission(AxiosFn, setPermission, DialogFn);

    getFormInitial();
  }, []);

  return (
    <Grid item container justifyContent={"flex-end"} mt={1} spacing={2}>
      <FormProvider {...formSearch}>
        <Grid item container xs={12} spacing={1}>
          <Grid item md={2} xs={12}>
            <DatePickerItem
              id={`dStart`}
              name={`dStart`}
              required
              fullWidth
              label={`${I18n.SetText("TimeAttendance.sStartDateAdmin")}`}
              onChange={(e) => {
                setStart(e);
                if (e) {
                  formSearch.setValue("dEnd", null);
                }
              }}
              disabled={false}
            />
          </Grid>
          <Grid item md={2} xs={12}>
            <DatePickerItem
              id={`dEnd`}
              name={`dEnd`}
              required
              minDate={dStart}
              fullWidth
              label={`${I18n.SetText("TimeAttendance.sEndDateAdmin")}`}
              disabled={false}
            />
          </Grid>
          <Grid item flex={1}>
            <MultipleSelectItem
              id={"selName"}
              name={"arrName"}
              label={`${I18n.SetText("TimeAttendance.sName")}`}
              options={arrName || []}
              disabled={false}
              limitTag={1}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <MultipleSelectItem
              id={"selStatus"}
              name={"arrStatus"}
              label={`${I18n.SetText("TimeAttendance.sStatus")}`}
              options={arrStatusSearch || []}
              disabled={false}
              limitTag={2}
            />
          </Grid>
          <Grid item>
            <BtnSearch
              id={"btnSearch"}
              IsCircleWithOutText
              onClick={formSearch.handleSubmit(
                () => handleSearch(),
                (err) => console.log("err", err)
              )}
            />
          </Grid>
        </Grid>
      </FormProvider>

      <FormProvider {...form}>
        <Grid item xs={12}>
          <DataGrid
            sTableID={`tbAttendance`}
            columns={dataColumn}
            rows={dataRow}
            onLoadData={getTable}
            isLoading={loadingTable}
            isHiddenToolHead
            isHiddenFooter
            isShowCheckBox={nPermission}
            onSelectChange={(e) => handleSelectChange(e)}
          />
        </Grid>
      </FormProvider>

      <Grid item xs={12}>
        <Typography fontWeight={"bold"}>{`${I18n.SetText(
          "TimeAttendance.sDocRefEdit"
        )}`}</Typography>
      </Grid>
      {lstMonthlyDoc.map((m) => (
        <Grid key={m.sLabel} item container xs={12} mt={1}>
          <Grid item md={"auto"} xs={12} sx={{ mr: 2 }}>
            {m.sLabel}
          </Grid>
          <Grid item flex={1} md={"auto"} xs={12}>
            {m.nOrder === 1 ? (
              <UploadFile
                id={"arrMonthlyFile_1" + m.nOrder}
                name={"arrMonthlyFile_1" + m.nOrder}
                key={"arrMonthlyFile_1" + m.nOrder}
                IsDrag={false}
                required={false}
                arrFile={arrMonthlyFile_1}
                setarrFile={setArrMonthlyFile_1}
                IsFolder={false}
                IsMultiple={true}
                Extension={arrExtentionMonthlyFile}
                nLimitFile={30}
                sLimitFile={"MB"}
                onClearFile={handleClearMonthlyFile_1}
                modeDisplay={"list"}
                sFolderTemp={""}
                IsMultiDelete={false}
                sPositionText={"right"}
                disabled={!nPermission}
              />
            ) : (
              <UploadFile
                id={"arrMonthlyFile_2" + m.nOrder}
                name={"arrMonthlyFile_2" + m.nOrder}
                key={"arrMonthlyFile_2" + m.nOrder}
                IsDrag={false}
                required={false}
                arrFile={arrMonthlyFile_2}
                setarrFile={setArrMonthlyFile_2}
                IsFolder={false}
                IsMultiple={true}
                Extension={arrExtentionMonthlyFile}
                nLimitFile={30}
                sLimitFile={"MB"}
                onClearFile={handleClearMonthlyFile_2}
                modeDisplay={"list"}
                sFolderTemp={""}
                IsMultiDelete={false}
                sPositionText={"right"}
                disabled={!nPermission}
              />
            )}
          </Grid>
        </Grid>
      ))}

      {/* Action */}
      <Grid item xs={12}>
        <Grid container justifyContent="flex-start" sx={{ mt: 5 }}>
          <Grid item xs={6} md={6}>
            <BtnBack
              id={"btnBack"}
              onClick={() => navigate("/TimeAttendanceDetail")}
            />
          </Grid>

          {nPermission ? (
            <>
              <Grid container item xs={6} md={6} justifyContent="flex-end">
                <BtnSave
                  id={"btnSave"}
                  onClick={form.handleSubmit(
                    () => handleSubmit(),
                    (err) => console.log("err", err)
                  )}
                />
              </Grid>
            </>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>

      {/* Dialog Upload files */}
      <DialogPreview
        IsOpen={IsOpenUpload}
        Title={`${I18n.SetText("TimeAttendance.sAttachFile")}`}
        required={true}
        onClose={() => {
          handleConfirmUpload();
        }}
        sMaxWidth="sm"
        CloseSave={true}
      >
        <Box sx={{ marginLeft: 1 }}>
          <UploadFile
            id={`arrAttachFile_${nNoUpload}`}
            name={`arrAttachFile_${nNoUpload}`}
            IsDrag={false}
            required={false}
            arrFile={arrAttachFile}
            setarrFile={setArrAttachFile}
            IsFolder={false}
            IsMultiple={false}
            Extension={[
              "jpg",
              "jpeg",
              "png",
              "pdf",
              "doc",
              "docx",
              "xlsx",
              "pptx",
            ]}
            nLimitFile={30}
            sLimitFile={"MB"}
            onClearFile={handleClearAttachFile}
            modeDisplay={"list"}
            sFolderTemp={""}
            IsMultiDelete={false}
            sPositionText={"right"}
            disabled={!nPermission}
          />
        </Box>

        <Box sx={{ height: "40px" }}></Box>
      </DialogPreview>
    </Grid>
  );
}
